<template>
	<section class="select-section">
		<el-dialog :visible.sync="dialogVisible" width="70%" center
		style='min-width: 700px;' @close='close'>
            <p slot="title">{{title}}</p>
            <div class="search-row">
                <!-- 搜索-->
                <el-input placeholder="请输入内容" v-model="selectVal.searchVal" class="input-with-select" @keyup.enter='getData' size='small' clearable>
                    <el-select class='search-select' v-model="selectVal.searchKey" slot="prepend" placeholder="请选择">
                        <el-option v-for='item in select.searchKey' :key='item.val'
                        :value="item.val" :label="item.name"></el-option>
                    </el-select>
                </el-input>
                <el-button type="primary" size='small'
                @click='pageIndex=1;getData()'>搜索</el-button>
            </div>
            <el-table :data="tableData" class="table_list" 
            style="width: 100%" border max-height="500"
            @row-click='rowClickHandle' highlight-current-row>
                <el-table-column label="选择" width="60px">
                    <template slot-scope="scope">
                        <div class="virtualBox"></div>
                        <el-checkbox v-model="choiceCourse" :label="scope.row">
                            {{ }}
                        </el-checkbox>
                    </template>
                </el-table-column>
		        <el-table-column label="名称" prop='title' min-width="10%">
		        </el-table-column>
	        	<el-table-column label="类型"
		            min-width="10%">
		            <template slot-scope='scope'>
		            	<span>{{scope.row.group ? scope.row.group.title : ''}}</span>
		            </template>
		        </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination class='el-pagination' @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                </el-pagination>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitHandle">确 定</el-button>
            </span>
        </el-dialog>
    </section>
</template>

<script scoped>
import tagApi from '@/api/contentManage/tagmanage2'
export default {
	name: "selectDoctor",
	data() {
		return {
			title: "",
			choiceCourse: [],
			dialogVisible: false,
			pageSize: 20,
			pageIndex: 1,
			totalCount: 0,
			tableData: [],
			select: {
				searchKey: [
				{
					val: 1,
					name: "关键字"
				}]
			},
			selectVal: {
				searchKey: 1,
				searchVal: ''
			}
		};
	},
	props: {
		isSingle: {
			type: Boolean,
			default: () => true
		}
	},
	methods: {
		open(title) {
			this.dialogVisible = true;
			this.choiceCourse = []
			this.title = title;
			this.getData();
		},
		close() {
			this.choiceCourse = []
		},
		submitHandle() {
			if(this.isSingle){
				this.$emit('select-submit', this.choiceCourse[0]||{})
				this.dialogVisible = false;
			}else{				
				this.$emit('select-submit', this.choiceCourse)
				this.dialogVisible = false;
			}
		},
		rowClickHandle(row) {
			if(this.isSingle){
				this.choiceCourse = [row]
			}else{
				var index = this.choiceCourse.indexOf(row)
				if(index == -1){
					this.choiceCourse.push(row)
				}else{
					this.choiceCourse.splice(index,1)
				}				
			}
		},
		getData() {
			var params = {
				key: this.selectVal.searchVal,
				pageIndex: this.pageIndex,
				pageSize: this.pageSize
			};
			tagApi.getTagList(params).then(res => {
				if (res.Success) {
					this.tableData = res.Data.dataList;
					this.totalCount = res.Data.totalCount;
					this.choiceCourse = []
				} else {
					this.$message.error(res.Msg);
				}
			}).catch(res => {
				this.$message.error('课程源获取出错，请刷新重试！')
			})
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.getData();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getData();
		}
	}
};
</script>

<style type="text/less" lang="less" scoped>
.select-section {
	.el-dialog__wrapper {
		background-color: rgba(0, 0, 0, 0.1);
	}
	.pagination-wrap {
		margin-top: 10px;
	}
	.el-pagination {
		float: right;
	}
	.dialog-footer {
		margin-top: 40px;
	}
}
.search-row {
	margin-bottom: 10px;
	.input-with-select {
		width: 30%;
	}
	.search-select {
		width: 120px;
	}
}
.search-row>div{
	margin: 5px 5px 5px 0;
	max-width: 270px;
}
.virtualBox{
	position: absolute;
	width: 100%;
	height: 100%;
	z-index: 9;
}
</style>
<style type="text/css">
.el-table .cell{
	position: relative;
}
</style>


// WEBPACK FOOTER //
// src/components/selectSource/selectTag.vue